// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, IconButton } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { deleteLanguage, getLanguages } from "../../features/language";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";

const Language = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { languages, status } = useSelector((state: any) => state.language);

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this language?");
    if (isConfirmed) {
      dispatch(deleteLanguage(id))
        .then((res) => {
          toast.success(res.payload.message);
          dispatch(getLanguages({ page: pageIndex, limit: pageSize }));
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const columns = [
   
    {
      header: "Language Code",
      accessorKey: "language_code",
      id: "language_code",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Language",
      accessorKey: "language",
      id: "language",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
   
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original.slug; 
        return (
          <div>
            <IconButton onClick={() => navigate(`/languages/edit/${id}`)}>
              <FaEdit />
            </IconButton>
            <IconButton onClick={() => handleDelete(id)}>
              <MdDelete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getLanguages({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    if (status && languages && languages?.data) {
      setData(languages.data);
      setTotalRows(languages.pagination.total);
    }
  }, [status, languages]);

  return (
    <DashboardLayout>
            <DashboardNavbar />
      
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={3} pb={1} px={3}>
              <SoftTypography variant="h5" fontWeight="bold">
                Language 
              </SoftTypography>
              <SoftButton onClick={() => navigate("/languages/add")} variant="contained" color="final">
                Add Language
              </SoftButton>
            </SoftBox>
            <SoftBox>
              <Table
              className="fn-align"
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default Language;
